import React from 'react'
import Header from './Header'
import Footer from './Footer'

const Layout = ({ children }) => {

    return (
        <div>
            <main>
            <Header></Header>
            {children}
            </main>
            <Footer></Footer>
        </div>
    )
}
export default Layout